import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentService } from '@eforall/common';
import { AppService, FuncService } from '../../services';


@Component({
	selector: 'home-page',
	imports: [
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './home.page.html'
})
export class HomePage {

	public env = inject(EnvironmentService);
	private func = inject(FuncService);
	public app = inject(AppService);

	async getAppData() {
		await this.func.getData();
	}

}
